module.exports = __webpack_public_path__ + "img/logo.373a245c.png";